<template>
  <div class="row">
    <div class="col">
      <a
        id=""
        class="btn-confirm-alert btn btn-secondary w-100"
        href="#"
        @click.prevent="confirm(index)"
      >
        <span>確定</span>
      </a>
    </div>
    <div class="col">
      <a
        id=""
        class="btn-cancel-alert btn btn-outline-secondary w-100"
        href="#"
        @click.prevent="closeAlert(index)"
      >
        <span>取消</span>
      </a>
    </div>
  </div>
</template>

<script setup>
import useAlert from '@global/composable/useAlert';

const { closeAlert } = useAlert();

const props = defineProps({
  alert: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
});

function confirm(index) {
  closeAlert(index);
  props.alert.callback();
}
</script>
